;(function () {
  'use strict';

  const angular = window.angular;

  CustomerProfileController.$inject = ['$uibModal', '$state', 'LoopBackAuth', 'AppUtils'];

  angular
    .module('app')
    .component('customerProfile', {
      template:'<div class="well well-light"><div class="profile-content"><div class="profile-left"><div class="profile-left-fix"><div class="text-center thumbnail marginB10"><img ng-if="ctrl.organization.image" ng-src="{{ctrl.organization.image}}"> <img ng-if="!ctrl.organization.image" ng-src="{{$root.assetsPath}}/images/no-image.png"></div><button class="btn btn-block btn-warning marginB20" ng-click="ctrl.showImageModal()" translate>buttons.change</button></div></div><div class="profile-right"><div class="table-responsive"><table class="table table-borderless no-margin"><thead><tr><th colspan="2"><div class="pull-left"><h2 class="no-margin text-info"><span>{{ctrl.organization.name}}</span></h2><h3 class="no-margin" ng-if="ctrl.organization.businessName">{{ctrl.organization.businessName}}</h3></div><button class="btn txt-color-white btn-warning btn-sm pull-right" ng-click="ctrl.showEditModal()"><i class="fas fa-edit"></i></button></th></tr></thead><tbody><tr class="separator"><td colspan="2"></td></tr><tr class="bordered"><td class="field" translate>entities._all.address</td><td>{{ctrl.organization.address}}</td></tr><tr class="bordered"><td class="field" translate>entities._all.description</td><td><p>{{ctrl.organization.description}}</p></td></tr></tbody></table></div></div></div></div><div class="panel panel-default"><header class="panel-heading"><h2 class="nowrap"><strong translate>entities.organization.members</strong></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar"><button class="btn btn-primary" ng-click="ctrl.showCreateUserModal()"><i class="fas fa-plus"></i></button></div></div></header><div class="panel-body no-padding"><users-table users="ctrl.users" edit="true" remove="true" time-zones="ctrl.timeZones" countries="ctrl.countries"></users-table></div></div><tool-kits-table customer-id="ctrl.customer.id" entity-type="\'customer\'" add-new="true"></tool-kits-table>',
      controller: CustomerProfileController,
      controllerAs: 'ctrl',
      bindings: {
        timeZones: '<',
        countries: '<',
        customer: '<',
        users: '<',
        varId: '<',
      }
    });

  function CustomerProfileController ($uibModal, $state, LoopBackAuth, utils) {
    let vm = this;

    vm.$onInit = function () {
      vm.image = {};
      vm.showImageModal = showImageModal;

      if (vm.customer.container && vm.customer.container._logo) {
        let logo = vm.customer.container._logo;
        vm.customer.image = utils.getEntityFileUrl('Customer', vm.customer.id, 'logo', logo, LoopBackAuth.accessTokenId);
      }

      vm.organization = vm.customer;

      vm.showEditModal = showEditModal;
      vm.showCreateUserModal = showCreateUserModal;
    };

    function showEditModal () {
      let instance = $uibModal
        .open({
          animation: true,
          backdrop: 'static',
          bindToController: true,
          component: 'customerForm',
          resolve: {
            customer: () => vm.customer,
            timeZones: () => vm.timeZones,
            countries: () => vm.countries,
            varId: () => vm.varId
          }
        });

      instance
        .result
        .then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function showImageModal () {
      let instance = $uibModal
        .open({
          animation: true,
          bindToController: true,
          backdrop: 'static',
          component: 'accountProfileImage',
          resolve: {
            entityId: function () {return vm.customer.id;},
            entity: function () {
              return 'Customer';
            },
            property: function () {
              return 'logo';
            }
          }
        });

      instance
        .result
        .then(function (result) {
          if (result.files && result.files.file && result.files.file.length) {
            let file = result.files.file[0];
            vm.customer.image = utils.getEntityFileUrl('Customer', vm.customer.id, 'logo', file, LoopBackAuth.accessTokenId);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function showCreateUserModal () {
      let instance = $uibModal
        .open({
          animation: false,
          bindToController: true,
          backdrop: 'static',
          component: 'managerForm',
          size: 'lg',
          resolve: {
            customerId: function () {
              return vm.organization.id;
            },
            user: function () {
              return {};
            },
            countries: function () {
              return vm.countries;
            },
            timezones: function () {
              return vm.timeZones;
            }
          }
        });

      instance
        .result
        .then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }
})();

